import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    text: {
      primary: "#000000",
      secondary: "#FFFFFF",
    },
    background: {
      default: "#121212",
    },
  },
  typography: {
    MBCORPOA: "MB Corpo A Title Condensed,Chinese_Regular",
    MBCORPOS: "MB Corpo S Title,Chinese_Regular",
    h2: {
      fontSize: "60px",
      letterSpacing: "0.5px",
      color: "#ffffff",
      fontFamily: "MB Corpo S Title,Chinese_Regular",
      transformOrigin: "left",
    },
    h3: {
      fontSize: "46px",
      letterSpacing: "0.5px",
      lineHeight: "46px",
      color: "#ffffff",
      fontFamily: "MB Corpo A Title Condensed,Chinese_Regular",
      transformOrigin: "left",
    },
    h4: {
      fontSize: "36px",
      letterSpacing: "0.5px",
      lineHeight: "36px",
      color: "#ffffff",
      fontFamily: "MB Corpo A Title Condensed,Chinese_Regular",
      transformOrigin: "left",
    },
    h5: {
      fontFamily: "MB Corpo A Title Condensed,Chinese_Regular",
      transformOrigin: "left",
      fontSize: "32px",
    },
    h6: {
      fontSize: "18px",
      fontFamily: "MB Corpo A Title Condensed, Chinese_Regular",
    },
    body2: {
      fontFamily: "MB Corpo A Title Condensed, Chinese_Regular",
    },
    body1: {
      fontSize: 18,
      letterSpacing: "0.5px",
      lineHeight: "18px",
      color: "#ffffff",
      fontFamily: "MB Corpo A Title Condensed, Chinese_Regular",
    },
    body3: {
      fontSize: 16,
      letterSpacing: "0.5px",
      lineHeight: "24px",
      color: "#999999",
      fontFamily: "MB Corpo A Title Condensed, Chinese_Regular",
    },
  },
});

export default theme;
